module.exports = __webpack_public_path__ + "img/person.d62ccf31.svg";